// ColumnsMenu — „Spalten"-Button + Popover zum Aus-/Einblenden von Spalten.
// Eigenständig (z.B. in der Toolbar platzierbar) statt als eigener fixer Streifen
// über der Tabelle. Nutzt das portalierte RdPopover.

import { RdPopover } from "./RdPopover";
import type { Column } from "./DataTable";

const ColumnsIcon = (
  <svg width="15" height="15" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinejoin="round">
    <rect x="2.5" y="3" width="13" height="12" rx="1.5" />
    <path d="M7 3v12M11 3v12" />
  </svg>
);

export function ColumnsMenu<T>({
  columns,
  columnVisibility,
  onColumnVisibilityChange,
  collapsedColumns,
  onToggleCollapsed,
  label = "Spalten",
}: {
  columns: Column<T>[];
  columnVisibility?: Record<string, boolean>;
  onColumnVisibilityChange: (next: Record<string, boolean>) => void;
  collapsedColumns?: string[];
  onToggleCollapsed?: (id: string) => void;
  label?: string;
}) {
  const labelOf = (c: Column<T>) => c.label ?? (typeof c.header === "string" ? c.header : c.id);
  return (
    <RdPopover
      align="end"
      width={220}
      trigger={({ toggle, ref }) => (
        <button ref={ref} type="button" className="kt-util-btn" title="Spalten" onClick={toggle}>
          {ColumnsIcon}
          <span>{label}</span>
        </button>
      )}
    >
      {() => (
        <div className="rd-pop-body" onClick={(e) => e.stopPropagation()}>
          <div className="rd-pop-grouptitle">Spalten anzeigen</div>
          <div className="rd-pop-scroll">
            {columns
              .filter((c) => c.hideable && !c.pinned)
              .map((c) => {
                const visible = columnVisibility?.[c.id] !== false;
                const collapsed = collapsedColumns?.includes(c.id) === true;
                return (
                  <div key={c.id} className="rd-pop-row">
                    <label className="rd-pop-check">
                      <input
                        type="checkbox"
                        checked={visible}
                        onChange={() =>
                          onColumnVisibilityChange({
                            ...(columnVisibility ?? {}),
                            [c.id]: !visible,
                          })
                        }
                      />
                      {labelOf(c)}
                    </label>
                    {c.collapsible && onToggleCollapsed && visible && (
                      <button
                        type="button"
                        className={"rd-pop-collapse" + (collapsed ? " is-collapsed" : "")}
                        title={collapsed ? "Ausklappen" : "Einklappen"}
                        aria-label={collapsed ? "Ausklappen" : "Einklappen"}
                        onClick={() => onToggleCollapsed(c.id)}
                      >
                        {collapsed ? "›" : "‹"}
                      </button>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </RdPopover>
  );
}
